module.exports = __webpack_public_path__ + "static/img/deportes.8b456891.jpg";